/**
 * HSplitContainer parser: delegates to the shared SplitContainer base
 * (Control plus `split_offset`, `collapsed`, `dragger_visibility`). The axis
 * is the only thing this slice adds, and it is a Component concern.
 */
import { parseSplitContainer } from '../shared/splitContainer';
export function parseHSplitContainer(heading, properties) {
    return parseSplitContainer(heading, properties);
}
//# sourceMappingURL=parser.js.map